module.exports = __webpack_public_path__ + "img/about-00.665779ab.jpg";